import { createStore } from 'vuex'
import user from './modules/user';

export default createStore({
  state: {
    type: "chinese",
    sidebarOpen: false,
    cdkeyPer: '', // 存储CDK结果
    cdkeyEnt: '', // 存储CDK结果
    isCdkExchange: false, // 是否兑换CDK
    secretKey: "8sGd2pRk9mXb7qAz0cVjF5nH4tLwY1eU6i=" // 密钥
  },
  mutations: {
    setEnglish(state) {
      state.type = "english";
    },
    setChinese(state) {
      state.type = "chinese";
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarOpen = !state.sidebarOpen
    },
    SET_CDKEY_PER(state, cdkey) {
      state.cdkeyPer = cdkey
    },
    SET_CDKEY_ENT(state, cdkey) {
      state.cdkeyEnt = cdkey
    },
    // 是否兑换cdk
    IS_CDKEY_EXCHANGE(state, isExchanged) {
      state.isCdkExchange = isExchanged
    },
    // 设置 secretKey
    SET_SECRET_KEY(state, newKey) {
      state.secretKey = newKey
    }
  },
  actions: {
    updateSharedData({ commit }, newData) {
      commit('SET_SHARED_DATA', newData)
    },
    incrementCounter({ commit }) {
      commit('INCREMENT_COUNTER')
    },
    updatecdkeyPer({ commit }, cdkey) {
      commit('SET_CDKEY_PER', cdkey)
    },
    updatecdkeyEnt({ commit }, cdkey) {
      commit('SET_CDKEY_ENT', cdkey)
    },
    // 是否兑换cdk
    isExchangeCdk({ commit }, isExchanged) {
      commit('IS_CDKEY_EXCHANGE', isExchanged)
    },
    // 获取 secretKey（如果需要从接口获取）
    fetchSecretKey({ commit }) {
      // 如果 secretKey 需要从接口获取，可以在这里调用 API
      // 这里暂时直接使用已有的值，如果需要可以取消注释
      // const secretKey = "R8tYqW3zPxLmKjN9bVcH5sDfG7iJk2nA4eF6hT0rU1oQwX=";
      // commit('SET_SECRET_KEY', secretKey);
    },
    // 更新 secretKey（如果需要动态更新）
    updateSecretKey({ commit }, newKey) {
      commit('SET_SECRET_KEY', newKey)
    }
  },
  getters: {
    cdkeyResultPer: (state) => state.cdkeyPer,
    cdkeyResultEnt: (state) => state.cdkeyEnt,
    cdkeyResultExchange: (state) => state.isCdkExchange,
    // 获取 secretKey
    secretKey: (state) => state.secretKey
  },
  modules: {
    user,
  }
})